import * as React from "react";
import {
  useGetPortfolioLinkQuery,
  useDeletePortfolioLinkMutation,
} from "../store/portfolioApi";
import { useSelector } from "react-redux";
import { Trash } from "lucide-react";
import { RootState } from "@/types";
import { toast } from "sonner";

const PortfolioComponent = ({ studentId }) => {
  const { user } = useSelector((state: RootState) => state.user);
  const { data, error, isLoading, refetch } =
    useGetPortfolioLinkQuery(studentId);

  // Destructure the delete mutation trigger and its state
  const [deletePortfolioLink, { isLoading: isDeleting }] =
    useDeletePortfolioLinkMutation();

  const handleDelete = async () => {
    try {
      await deletePortfolioLink({
        portfolioId: data[0]._id,
        token: user?.token,
        studentId: data[0].studentId,
      }).unwrap();

      toast.success("Portfolio deleted successfully!");
    } catch (err) {
      toast.error(err || "Failed to delete portfolio.");
    }
    refetch();
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading portfolio link.</div>;

  return (
    <div className="flex items-center space-x-2">
      {data && data.length > 0 ? (
        <>
          <h2>
            Portfolio:{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={data[0]?.portfolio}
              className="text-blue-500"
            >
              {data[0]?.portfolio}
            </a>
          </h2>
          <Trash
            onClick={handleDelete}
            className="cursor-pointer text-red-600"
            size={18}
          />
          {isDeleting && <span>Deleting...</span>}
        </>
      ) : (
        <h2>Portfolio not found</h2>
      )}
    </div>
  );
};

export default PortfolioComponent;
